import { Stack } from '@mui/material';
import { useState } from 'react';

import { ExtendedIconButton } from '../shared/extendedIconButton';

interface CopyToClipboardProps {
  textToCopy?: string;
  tooltip?: string;
  ariaLabel?: string;
}

export default function CopyToClipboardButton(props: CopyToClipboardProps) {
  const { textToCopy, tooltip = 'Copy to clipboard', ariaLabel } = props;
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = () => {
    if (!textToCopy) return;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000); // Reset the tooltip after 2 seconds
      })
      .catch(() => {
        setCopySuccess(false);
      });
  };

  return (
    <ExtendedIconButton
      tooltip={
        copySuccess ? (
          <Stack direction='row' alignItems='center' gap='4px'>
            <i className='material-symbols-check text-[18px]' /> Copied
          </Stack>
        ) : (
          tooltip
        )
      }
      aria-label={ariaLabel || tooltip}
      onClick={handleCopy}
      disabled={!textToCopy}
    >
      <i className='material-symbols-content-copy-outline' />
    </ExtendedIconButton>
  );
}
